import styled from '@emotion/styled';
import TextField, { TextFieldProps } from '@mui/material/TextField/TextField';

const StyledTextField = styled(TextField)`
  .MuiTextField-root {
    margin: 1rem;
  }
  &.MuiFormControl-root {
    border-radius: 5px;
  }
`;

export const MHMTextField: React.FC<TextFieldProps> = (
  props: TextFieldProps,
) => {
  return (
    <StyledTextField
      slotProps={
        props.slotProps ?? {
          formHelperText: { sx: { fontSize: 'inherit', mt: 0 } },
        }
      }
      size="small"
      {...props}
    />
  );
};
